import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

// Use $primary and $secondary to avoid passing these props to the DOM
const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.medium};
  font-size: ${theme.typography.fontSizes.medium};
  font-weight: 700;
  transition: all 0.2s ease;
  min-height: 50px;
  width: 100%;
  
  ${props => props.$primary && `
    background-color: ${theme.colors.brandYellow};
    color: ${theme.colors.deepNavy};
    
    &:hover {
      background-color: #e6bc00;
    }
  `}
  
  ${props => props.$secondary && `
    background-color: ${theme.colors.white};
    color: ${theme.colors.deepNavy};
    border: 2px solid ${theme.colors.brandYellow};
    
    &:hover {
      background-color: rgba(255, 209, 0, 0.1);
    }
  `}
`;

export const Button = ({ children, primary, secondary, ...props }) => {
  return (
    <StyledButton 
      $primary={primary} 
      $secondary={secondary} 
      {...props}
    >
      {children}
    </StyledButton>
  );
};
